import React, { ReactNode } from "react";
import "../../assets/styles/auth.css";

/**
 * Two-panel authentication shell.
 * Left: brand / marketing panel (matches the project's blue identity).
 * Right: whatever auth form is passed as children.
 */
const AuthLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="auth-page">
      <aside className="auth-left">
        {/* Brand */}
        <div className="auth-brand">
          <svg
            className="auth-brand-mark"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle cx="32" cy="32" r="30" stroke="#ffffff" strokeWidth="3" />
            <path
              d="M46 20 L24 34 L31 37 L34 45 L38 37 L46 20 Z"
              fill="#ffffff"
            />
            <path d="M31 37 L34 45 L37 38 Z" fill="#cfe0ff" />
          </svg>
          <div>
            <div className="auth-brand-name">AUTO LEAD GEN</div>
            <div className="auth-brand-tag">MORE LEADS, LESS STRESS.</div>
          </div>
        </div>

        {/* Hero */}
        <div className="auth-hero">
          <span className="auth-pill">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2 L20 5 V11 C20 16 16.5 20 12 22 C7.5 20 4 16 4 11 V5 Z"
                stroke="#ffffff"
                strokeWidth="1.8"
                strokeLinejoin="round"
              />
            </svg>
            SMARTER LEAD GENERATION
          </span>
          <h1>Turn outreach into your next growth engine.</h1>
          <p>
            Build targeted campaigns, discover qualified prospects, and keep
            every lead moving from one focused workspace.
          </p>
        </div>

        {/* Team */}
        <div className="auth-team">
          <div className="auth-avatars">
            <span>AS</span>
            <span>MR</span>
            <span>JK</span>
          </div>
          <div className="auth-team-text">
            <strong>Built for high-performing teams</strong>
            <small>Campaign intelligence without the busywork.</small>
          </div>
        </div>
      </aside>

      <main className="auth-right">
        <div className="auth-card">{children}</div>
      </main>
    </div>
  );
};

export default AuthLayout;
